import messageResource from '../../../messageResource'
import TemplateView from '../../../TemplateView'
import CounterHeader from './CounterHeader'
import {ManagementAssignmentsSelection} from 'constants'
import DisabledContainer from '../../../util/DisabledContainer'
import {formatFmlWithCheck} from '../../../util/UserNameFormat'
import CopyContent from '../editManagementAssignmentsPanel/components/CopyContent'
import ScrollableContainer from '../../../util/ScrollableContainer'
import LoadingContainer from '../../../util/LoadingContainer'

export default class ManagementAssignmentsPanelContent extends TemplateView {
    constructor({
        tabContent = null,
        showCopyButton = true,
        onManagementAssignmentsSelectionChange = () => {},
        onBackButtonClick = () => {},
        onTabChanged = (tab) => {},
        onClickDialogContent = () => {},
        openEditorPanel = () => {},
        onCloseButtonClick = () => {},
        onCopyFromButtonClick = () => {},
    }) {
        super()

        this.params = {
            tabContent,
            showCopyButton,
            onManagementAssignmentsSelectionChange,
            onBackButtonClick,
            onClickDialogContent,
            onTabChanged,
            openEditorPanel,
            onCloseButtonClick,
            onCopyFromButtonClick,
        }

        this.state = {
            managementAssignmentsSelection: ManagementAssignmentsSelection.SELECTED,
            userFML: null,
            withBackButton: true,
            openTab: null,
            showCopyContent: false,
            copyContentLoading: false,

            counters: {
                customers: 0,
                projects: 0,
                tasks: 0,
            },
        }

        this.onAnyStatePropertyChanged(['openTab', 'showCopyContent'], ({openTab, showCopyContent}) => {
            this.counterHeader.setState({tab: showCopyContent ? null : openTab})
            this.$tabContent.toggle(!showCopyContent)
            this.$copyButton.toggleClass('selected', showCopyContent)
            this.$separator.toggleClass('invisible', showCopyContent)
        })

        this.onStatePropertyChanged('counters', (counters) => {
            this.counterHeader.setState({counters: counters})
        })

        this.onStatePropertyChanged('managementAssignmentsSelection', () => this._updateRadio())

        this.onStatePropertyChanged('userFML', userFML => {
            this.$headerLabel.text(messageResource.getMessage('management_assignment.panel.title', [formatFmlWithCheck(userFML)]))
        })

        this.onStatePropertyChanged('withBackButton', (withBackButton) => {
            this.$backButton.toggle(withBackButton)
        })

        this.onStatePropertyChanged('copyContentLoading', loading => this.copyContentWrapper.setState({loading}))
    }

    templateHtml() {
        return '<div class="managementAssignmentsPanel">' +
               '   <div class="header">' +
               '        <div class="backButton">' +
               '            <div class="arrow"></div>' +
               '            <div class="text"><%-backButton%></div>' +
               '        </div>' +
               '        <div class="headerText"></div>' +
               '        <div class="crossButton"></div>' +
               '   </div>' +
               '   <div class="managementAssignmentsPanelContent">' +
               '       <div class="radioSection">' +
               '           <label>' +
               '               <div class="noAccessSection sectionRow">' +
               '                    <input type="radio" class="noAccess"/>' +
               '                    <div class="icon"></div>' +
               '                    <span><%-noAccessLabel%></span>' +
               '                </div>' +
               '            </label>' +
               '            <label>' +
               '                <div class="allSection sectionRow">' +
               '                    <input type="radio" class="selectAll"/>' +
               '                    <div class="icon"></div>' +
               '                    <span><%-selectAllLabel%></span>' +
               '                </div>' +
               '            </label>' +
               '            <label class="customSectionLabel">' +
               '                <div class="customSection sectionRow">' +
               '                    <div class="option">' +
               '                        <input type="radio" class="customSelect"/>' +
               '                        <div class="icon"></div>' +
               '                        <span><%-customSelectLabel%></span>' +
               '                    </div>' +
               '                    <div class="counterTabPlaceholder"/>' +
               '                    <div class="buttonsContainer">' +
               '                        <div class="vertical-separator first"></div>' +
               '                        <div class="editAssignmentButton"><%-editButtonTitle%></div>' +
               '                        <div class="vertical-separator last"></div>' +
               '                        <div class="copyButton">' +
               '                            <div class="copyButtonImg"/>' +
               '                            <div class="copyButtonLabel"><%-copyButtonLabel%></div>' +
               '                        </div>' +
               '                    </div>' +
               '                </div>' +
               '            </label>' +
               '        </div>' +
               '        <div class="tabContentPlaceholder"/>' +
               '        <div class="copyContentPlaceholder"/>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            noAccessLabel: 'management_assignment.panel.no_access',
            selectAllLabel: 'management_assignment.panel.entire_scope',
            customSelectLabel: 'management_assignment.panel.custom_scope',
            backButton: 'user.panel.permissions.team_assignments.back_to_permission',
            editButtonTitle: 'common.edit',
            copyButtonLabel: 'management_assignment.panel.copy_button',
        }
    }

    afterRender() {
        this.$headerLabel = this.find('.headerText')
        this.$backButton = this.find('.backButton')
        this.$crossButton = this.find('.crossButton')

        this.$noAccessSection = this.find('.noAccessSection')
        this.$selectAllSection = this.find('.allSection')
        this.$customSection = this.find('.customSection')
        this.$noAccessRadio = this.find('.noAccess')

        this.$selectAllRadio = this.find('.selectAll')
        this.$customSelectRadio = this.find('.customSelect')
        this.$editButton = this.find('.editAssignmentButton')
        this.$separator = this.find('.vertical-separator')
        this.$copyButton = this.find('.copyButton')
        this.$tabContent = this.find('.tabContentPlaceholder')
        this.$copyContent = this.find('.copyContentPlaceholder')
        this.$buttonsContainer = this.find('.buttonsContainer')
        this.$buttonsContainer.toggleClass('withCopyButton', this.params.showCopyButton)

        this.$el.click((e) => this.params.onClickDialogContent(e))

        this.$backButton.on('click', () => this.params.onBackButtonClick())

        this.$crossButton.on('click', () => this.params.onCloseButtonClick())
        this.$crossButton.addClass('hideButton_panelContainer')

        // Prevent hide Edit Scope panel by click outside, second click event triggering by label with input
        const $customSectionLabel = this.find('.customSectionLabel')
        $customSectionLabel.click(e => {
            if (this.state.managementAssignmentsSelection === ManagementAssignmentsSelection.SELECTED)
                e.stopPropagation()
        })

        this.$noAccessRadio.on('change', () => this.params.onManagementAssignmentsSelectionChange(ManagementAssignmentsSelection.NO))
        this.$selectAllRadio.on('change', () => this.params.onManagementAssignmentsSelectionChange(ManagementAssignmentsSelection.ALL))
        this.$customSelectRadio.on('change', () => this.params.onManagementAssignmentsSelectionChange(ManagementAssignmentsSelection.SELECTED))

        this.$editButton.click(e => {
            if (this.state.managementAssignmentsSelection === ManagementAssignmentsSelection.SELECTED) {
                this.params.openEditorPanel()
                e.stopPropagation()
            }
        })

        if (this.params.showCopyButton) {
            this.$copyButton.click(e => {
                if (this.state.managementAssignmentsSelection === ManagementAssignmentsSelection.SELECTED) {
                    this.params.onCopyFromButtonClick()
                    e.stopPropagation()
                }
            })
        }

        this.counterHeader = new CounterHeader({
            changeTab: (tab) => this.params.onTabChanged(tab)
        })

        this.counterHeaderWrapper = new DisabledContainer({
            contentComponent: this.counterHeader,
            containerClass: 'counterHeaderWrapper'
        }).init(this.find(".counterTabPlaceholder"))

        this.tabContentWrapper = new DisabledContainer({
            contentComponent: this.params.tabContent
        }).init(this.$tabContent)

        this.copyContent = new CopyContent({
            refreshScrollCb: () => this.copyContentScrollableWrapper.forceUpdate()
        })
        this.copyContentScrollableWrapper = new ScrollableContainer(null, this.copyContent, {triggerScrollEvent: false})
        this.copyContentWrapper = new DisabledContainer({
            contentComponent:  new LoadingContainer({
                contentComponent: this.copyContentScrollableWrapper,
                containerClass: 'copyContentWrapper',
                loadingMoireConfig: {
                    delay: 500,
                }
            }),
            containerClass: 'copyContentWrapper',
        }).init(this.$copyContent)

        this.renderInitialState()
    }

    update() {
        this.params.tabContent.update()
    }

    _updateRadio() {
        this.$noAccessRadio.prop('checked', this.state.managementAssignmentsSelection === ManagementAssignmentsSelection.NO)
        this.$selectAllRadio.prop('checked', this.state.managementAssignmentsSelection === ManagementAssignmentsSelection.ALL)
        this.$customSelectRadio.prop('checked', this.state.managementAssignmentsSelection === ManagementAssignmentsSelection.SELECTED)

        this.$noAccessSection.toggleClass('selected', this.state.managementAssignmentsSelection === ManagementAssignmentsSelection.NO)
        this.$selectAllSection.toggleClass('selected', this.state.managementAssignmentsSelection === ManagementAssignmentsSelection.ALL)
        this.$customSection.toggleClass('selected', this.state.managementAssignmentsSelection === ManagementAssignmentsSelection.SELECTED)

        this.counterHeaderWrapper.setState({disabled: this.state.managementAssignmentsSelection !== ManagementAssignmentsSelection.SELECTED})
        this.tabContentWrapper.setState({disabled: this.state.managementAssignmentsSelection !== ManagementAssignmentsSelection.SELECTED})
        this.copyContentWrapper.setState({disabled: this.state.managementAssignmentsSelection !== ManagementAssignmentsSelection.SELECTED})

        this.$editButton.toggleClass('notAvailable', this.state.managementAssignmentsSelection !== ManagementAssignmentsSelection.SELECTED)
        this.$copyButton.toggleClass('notAvailable', this.state.managementAssignmentsSelection !== ManagementAssignmentsSelection.SELECTED)
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/managementAssignmentsPanel/ManagementAssignmentsPanelContent.js